import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { SET_PICKUP_DATE } from '../../redux/OffersDetails';
import icons from '../../helpers/Icons';
import PickupDateBar from './PickupDateBar';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
class PickupDateBarContainer extends PureComponent {
  state = {
    isSendFormDisabled: false,
  }
  handlePickupDateSubmit = () => {
    const { hashId, setPickupDate, newPickupDate } = this.props;
    setPickupDate({ hashId, pickUpDate: newPickupDate });
    this.setState({ isSendFormDisabled: typeof newPickupDate === 'string' });
  };

  render() {
    const {
      leftSideClassNames,
      handlePickupDateChange,
      pickupDateLabel,
      datepickerPlaceholder,
      isLoadingPickupDate,
      isLoadingPickedUpDate,
      pickedupSubmitLabel,
      pickedupCheckboxLabel,
      handleSetPickedUpDateSubmit,
      newPickupDate,
      sendDateToSellerLabel,
      sendLabel,
      cancelLabel,
      t,
    } = this.props;

    const pickupDateSubmitLabel = (
      <span>
        {icons('arrow_right')}
        {t('send_date_to_seller')}
      </span>
    );

    const isPickupDateSubmitDisabled = !newPickupDate;

    return (
      <PickupDateBar
        className={leftSideClassNames}
        handlePickupDateChange={handlePickupDateChange}
        pickupDateLabel={pickupDateLabel}
        datepickerPlaceholder={datepickerPlaceholder}
        handlePickupDateSubmit={this.handlePickupDateSubmit}
        isPickupDateSubmitDisabled={isPickupDateSubmitDisabled}
        isLoadingPickupDate={isLoadingPickupDate}
        isLoadingPickedUpDate={isLoadingPickedUpDate}
        pickupDateSubmitLabel={pickupDateSubmitLabel}
        isPickedUpSubmitDisabled={this.state.isSendFormDisabled}
        pickedupSubmitLabel={pickedupSubmitLabel}
        pickedupCheckboxLabel={pickedupCheckboxLabel}
        handlePickedupSubmit={handleSetPickedUpDateSubmit}
        sendDateToSellerLabel={sendDateToSellerLabel}
        sendLabel={sendLabel}
        cancelLabel={cancelLabel}
      />
    );
  }
}

PickupDateBarContainer.propTypes = {
  newPickupDate: PropTypes.string,
  leftSideClassNames: PropTypes.string.isRequired,
  handlePickupDateChange: PropTypes.func.isRequired,
  pickupDateLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  datepickerPlaceholder: PropTypes.string.isRequired,
  isLoadingPickupDate: PropTypes.bool.isRequired,
  isLoadingPickedUpDate: PropTypes.bool.isRequired,
  pickedupSubmitLabel: PropTypes.object.isRequired,
  pickedupCheckboxLabel: PropTypes.string.isRequired,
  handleSetPickedUpDateSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  setPickupDate: PropTypes.func.isRequired,
  sendDateToSellerLabel: PropTypes.string.isRequired,
  hashId: PropTypes.string.isRequired,
  sendLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
};

PickupDateBarContainer.defaultProps = {
  newPickupDate: '',
};

const mapStateToProps = (state) => {
  return {
    isLoadingPickupDate: get(state, ['offerDetails', 'isLoadingPickupDate']),
    isLoadingPickedUpDate: get(state, ['offerDetails', 'isLoadingPickedUpDate']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPickupDate: payload => dispatch(SET_PICKUP_DATE(payload)),
  };
};


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('details_date_bar')
  )(PickupDateBarContainer)